import React, { useEffect, memo, useState, useRef } from 'react'
import { useSprings, useSpring, animated, config } from '@react-spring/web'

import { ReactComponent as PlusIcon } from 'assets/uiIcons/plus.svg'
import { ReactComponent as MinusIcon } from 'assets/uiIcons/minus.svg'
import { ReactComponent as PlayIcon } from 'assets/uiIcons/play.svg'
import { ReactComponent as BackIcon } from 'assets/uiIcons/back.svg'

import { useApp,useCanvas } from 'store/AppStore'

import { Root, FeatureButton, FeatureButtonBlink } from './ContentLayer.styled.js'
import { CSSTransition } from 'react-transition-group'

import useAnalyticsEventTracker from 'lib/useAnalyticsEventTracker.jsx'
import { ScenarArray } from 'lib/useAnalyticsEventTracker.jsx'

const SPRING_DUR = 400

const ContentLayer = memo(
  ({ releaseYear, name, selected, showFeatures, toggleFeatures, isPortrait,setSelectedProduct }) => {
    const nameLetters = name.replace(/ /g, '\u00a0').split('')
    const numLetters = nameLetters.length
    const del = SPRING_DUR / numLetters
    const [playPop,setplayPop] = useState(false)
    const [canPlay,setcanPlay] = useState(false)
    const {CanvasState, playNextSeqence,seqName,seqTime } = useCanvas();
    const popRef = useRef(null);

    //const [num, setNum] = useState(0);

    /*
  function randomNumberInRange(min, max) {
    // 👇️ get number between min (inclusive) and max (inclusive)
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
*/


    const [springs, api] = useSprings(numLetters, (index) => ({
      from: {
        transform: `translate(${-index * 25}px, 400px) skew(60deg)`,
        opacity: 0,
        config: config.stiff,
      },
    }))

    const [yearStyles, yearApi] = useSpring(() => ({
      opacity: 0,
      letterSpacing: 100,
      delay: SPRING_DUR,
    }))

    useEffect(() => {
      if (selected) {
        api.start((index) => ({
          opacity: 1,
          transform: `translate(0px, 0px) skew(0deg)`,
          delay: index * del,
          reset: true,
        }))
        yearApi.start({
          opacity: 1,
          letterSpacing: 4,
          delay: SPRING_DUR,
        })
      } else {
        api.start((index) => ({
          opacity: 0,
          transform: `translate(-200px, 0px) skew(-45deg)`,
          delay: (index * del) / 2,
        }))
        yearApi.start({ opacity: 0, letterSpacing: 100, delay: SPRING_DUR })
      }
    }, [selected, api, del, yearApi])


// Permet de lancer la prochaine animation

 useEffect(() => {
  setcanPlay(true);
},[seqName])


// on arrive sur la page 3D on initialise les donnée

useEffect(() => {
  if (CanvasState){
      setcanPlay(true)
      setplayPop(false)
      //console.log("can_play_next: ")
  }
},[CanvasState])


// On play la séquence et on anim le bouton 
function playcanva(scene) {
  //console.log("play progress",canPlay,playPop)
  if (!canPlay) return
  setplayPop(true) // on play la progressbar  
  playNextSeqence() // on play la sequence
  setcanPlay(false); // on interdit un click tant qu'on a pas finit de player l'ancien
    
}
const gaEventTracker = useAnalyticsEventTracker('3Dpage');

const [currentScene, setCurrentScene] = useState(0)
const currentSceneRef = useRef(currentScene);

useEffect(() => {
  currentSceneRef.current = currentScene;
}, []);

useEffect(() => {
  if (!canPlay) {
    const nextScene = currentSceneRef.current > 5 ? 0 : currentSceneRef.current + 1;
    
    console.log('3DObjectPlayed on scene : ' + ScenarArray[currentSceneRef.current]);
    gaEventTracker('3DObjectPlayed on scene : ' + ScenarArray[currentSceneRef.current])
    setCurrentScene(nextScene); 
    currentSceneRef.current = nextScene; 
  }
}, [canPlay]);


//Si plus grand ou égal a 8 (slide) afficher les bouttons pour la dernière slide.
  return (
    <Root style={{pointerEvents:"none"}} selected={selected} isPortrait={isPortrait}>
      {window.utalk.selprodind !== 8 && <animated.div className="Year" style={yearStyles}>
        {releaseYear}
      </animated.div>}
      {window.utalk.selprodind !== 8 &&<div className="Name">
        {springs.map((styles, id) => (
          <animated.span key={id} style={styles}>
            {nameLetters[id]}
          </animated.span>
        ))}
      </div>}
      
      {window.utalk.selprodind === 8 ? <FeatureButtonBlink id={`senartrigger${selected?1:0}`} className='blink' style={window.utalk.selprodind < 8 ? {pointerEvents:"all"} : {pointerEvents:"all", left:"120px",position: "absolute"}} selected={selected} onClick={() => playcanva(1)}>
          <PlayIcon></PlayIcon>
          <CSSTransition
        in={playPop}
        timeout={{
            appear: (seqTime*1000),
            enter: (seqTime*1000),
            exit: 1000,
          }}
        nodeRef={popRef}
        classNames="popoverbt"
        onEntered={() => setplayPop(false)}
      >
          <div ref={popRef} className="rootbt"  >
            <div className="textPopOver" style={{transitionDelay: `${playPop ? ((seqTime*1000)-400) : 0}ms`}} >{seqName}</div>
            <div className="progress" style={{transition: `width ${playPop ? (seqTime*1000) : 1000}ms`}}></div>
          </div>
          </CSSTransition>
      </FeatureButtonBlink> : null}
      <FeatureButton id="boxkmore" style={window.utalk.selprodind < 8 ? {pointerEvents:"all"} : {pointerEvents:"all", left:"60px"}} selected={selected} onClick={() => toggleFeatures()}>
        {showFeatures ? <MinusIcon></MinusIcon> : <PlusIcon></PlusIcon>}
      </FeatureButton>
      {window.utalk.selprodind >= 8 && <FeatureButton  style={window.utalk.selprodind < 8 ? {pointerEvents:"all"} : {pointerEvents:"all", left:"0px"}} selected={selected} onClick={() => setSelectedProduct(7)}>
      <BackIcon></BackIcon>
      </FeatureButton>}
    </Root>
  )

}
)

// <div ref={popRef} className="rootbt" style={{transition: `opacity ${num}ms`}} >

//pointer event pour éviter le click sur le canvas


const WrappedContent = (props) => {
  const { showFeatures, toggleFeatures, isPortrait,setSelectedProduct } = useApp()
  return <ContentLayer  style={{pointerEvents:"none"}} {...props} {...{ showFeatures, toggleFeatures, isPortrait,setSelectedProduct }}></ContentLayer>
}

export default WrappedContent
